//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

//Material-ui
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';



import PartPageTitle from './PartPageTitle';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      newLoginPass: '',
      newLoginPassConfirm: '',
      newLoginPassError: null,
      newLoginPassConfirmError: null,
      newLoginPassSaveDialog: false,
    }
	}

  componentDidMount() {
    document.title = 'ログインパスワードの変更 - パートナーズ';
  }




  _newLoginPassEdit(value) {
    this.setState({ newLoginPass: value});
    let errorComment;

    if (value.length < 6 || value.length > 20) {
  		errorComment = '6～20文字で入力してください';
  	}
  	else if (value.match(/^[a-zA-Z0-9]+$/) == null) {
  		errorComment = '入力できない文字が含まれています';
  	}
    else if (value.match(/[a-zA-Z]+/) == null) {
      errorComment = '英字を１文字以上含めてください';
    }
    else if (value.match(/[0-9]+/) == null) {
      errorComment = '数字を１文字以上含めてください';
    }
  	if (errorComment) {
  		this.setState({newLoginPassError: errorComment});
  	}
  	else {
      this.setState({newLoginPassError: null});
    }
  }

  _newLoginPassConfirmEdit(value) {
    this.setState({newLoginPassConfirm: value});
    let errorComment;
    if (value.length < 6 || value.length > 20) {
      errorComment = '6～20文字で入力してください';
    }
    else if (value.match(/^[a-zA-Z0-9]+$/) == null) {
      errorComment = '入力できない文字が含まれています';
    }
    else if (value.match(/[a-zA-Z]+/) == null) {
      errorComment = '英字を１文字以上含めてください';
    }
    else if (value.match(/[0-9]+/) == null) {
      errorComment = '数字を１文字以上含めてください';
    }

    if (errorComment) {
      this.setState({newLoginPassConfirmError: errorComment});
    }
    else {
      this.setState({newLoginPassConfirmError: null});
    }
  }

  async _newLoginPassSaveCheck() {
    await this._newLoginPassEdit(this.state.newLoginPass);
    await this._newLoginPassConfirmEdit(this.state.newLoginPassConfirm);
    if (this.state.newLoginPass !== this.state.newLoginPassConfirm) {
      this.setState({newLoginPassConfirmError: '確認が一致しません'});
    }
    if (this.state.newLoginPassError === null && this.state.newLoginPassConfirmError === null) {
      this.setState({newLoginPassSaveDialog: true});
    }
  }

  _newLoginPassSave() {
    this.setState({newLoginPassSaveDialog: false});
    this.props.settingLoginPassEdit(this.state.newLoginPass, () => {

    })
  }


  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'ログインパスワードの変更'}
          onback={ '/setting/' }
          helpType={ 'category' }
          helpFilter={ 'post' }
        />

        <div style={{maxWidth:'400px', margin:'auto'}}>

          <div style={{padding:'10px'}}>
            <h3 align='center'>
              新しいパスワード
            </h3>
            <div>
              英数6～20文字
              <input
                type="text"
                value={ this.state.newLoginPass }
                style={{fontSize:'1.2em'}}
                className="input_blue round12"
                onChange={ (e) => this._newLoginPassEdit(e.target.value) }
              />
              <div style={{color:'red'}}>{this.state.newLoginPassError}</div>
            </div>
          </div>


          <div style={{padding:'10px'}}>
            <h3 align='center'>
              確認
            </h3>

            <div>
              新しいパスワードをもう一度
              <input
                type="text"
                value={ this.state.newLoginPassConfirm }
                style={{fontSize:'1.2em'}}
                className="input_blue round12"
                onChange={ (e) => this._newLoginPassConfirmEdit(e.target.value) }
              />
              <div style={{color:'red'}}>{this.state.newLoginPassConfirmError}</div>
            </div>
          </div>

          <div align='center' style={{padding:'10px'}}>
            <Button
              variant="contained"
              color="primary"
              style={{minWidth:'240px'}}
              onClick={ () => this._newLoginPassSaveCheck() }
              disabled={ (this.state.newLoginPass && !this.state.newLoginPassError && this.state.newLoginPassConfirm && !this.state.newLoginPassConfirmError) ? false : true }
            >
              <span style={{fontSize:'1.4em'}}>変更する</span>
            </Button>
          </div>
        </div>

        <DialogConfirm
          open={ this.state.newLoginPassSaveDialog }
          title={'ログインパスワードの変更'}
          content={(
            <div>
              <div>ログインパスワードを変更してもいいですか？</div>
            </div>
          )}
          apply={ () => this._newLoginPassSave() }
          close={ () => this.setState({newLoginPassSaveDialog: false}) }
        />

        <Snackbar
          open={this.state.saveSnackVisible}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          autoHideDuration={3000}
          onClose={ () => this.setState({saveSnackVisible: false})}
        >
          <MuiAlert severity="success" elevation={6} variant="filled">保存しました</MuiAlert>
        </Snackbar>

      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...uiAction,
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
